import { useId } from "react";
import { Box } from "@mui/material";

const GREY = "#54595F";
const BOX_BORDER = "#D1D5DB";

/**
 * Escudo em quadrantes (protótipo Permissões do Grupo): cantos TR e BL preenchidos,
 * TL e BR em branco com contorno; caixa arredondada com borda clara.
 */
export default function PermissoesGrupoShieldIcon({ boxSize = 28, iconSize = 18 }) {
  const uid = useId().replace(/:/g, "");
  const clipId = `perm-grupo-shield-${uid}`;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: boxSize,
        height: boxSize,
        borderRadius: "6px",
        border: `1px solid ${BOX_BORDER}`,
        bgcolor: "#fff",
        flexShrink: 0,
        boxSizing: "border-box",
      }}
      aria-hidden
    >
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id={clipId}>
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipId})`}>
          <path d="M0 0h12v12H0z" fill="#fff" stroke={GREY} strokeWidth="0.85" />
          <path d="M12 0h12v12H12z" fill={GREY} />
          <path d="M0 12h12v12H0z" fill={GREY} />
          <path d="M12 12h12v12H12z" fill="#fff" stroke={GREY} strokeWidth="0.85" />
        </g>
        <path
          d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
          fill="none"
          stroke={GREY}
          strokeWidth="1.05"
        />
      </svg>
    </Box>
  );
}
